import { enUS, fr, es, pt } from "date-fns/locale";
import type { Locale } from "date-fns";

/** Map CMS UI language code to a date-fns locale for date pickers. */
export function getDateFnsLocale(language: string): Locale {
    const primary = (language || "en").split(/[-_]/)[0].toLowerCase();
    switch (primary) {
        case "fr":
            return fr;
        case "es":
            return es;
        case "pt":
            return pt;
        default:
            return enUS;
    }
}
